import React, {FC} from 'react';

import {BillingUpgradeWantedFeaturesEnum} from '../../../../../libs/shared/billing/business/src/billingUpgradeTypes';
import {QueryClientProvider} from '../../../../../libs/shared/core/src/services/query/queryClient';
import {SettingsBillingEmptyScreenContainer} from '../../../../settings/billing/common/upgrade/settingsBillingEmptyScreen';

/*
 * Props.
 */

interface AnalyticsEmptyScreenUpsellProps {
  namespace: string;
}

/*
 * Component.
 */

export const AnalyticsEmptyScreenUpsell: FC<AnalyticsEmptyScreenUpsellProps> = ({namespace}) => (
  <QueryClientProvider>
    <SettingsBillingEmptyScreenContainer
      feature={BillingUpgradeWantedFeaturesEnum.ANALYTICS_217_RETENTION_DAYS}
      namespace={namespace}
      hasNoTitle
    />
  </QueryClientProvider>
);
